const EntryService = require('../services/EntryService').default;
const getSpace = require('./contentful/get-space');
const linkResolve = require('./contentful/link-resolve');
const transformer = require('./transformers/variantGroup');
const processError = require('./contentful/error-process');

let entryService = null;

const gettingEntryService = () => {
  if (!entryService) {
    entryService = getSpace().then((space) => {
      return new EntryService(space, transformer);
    });
  }

  return entryService;
};

module.exports = {
  getById(...parameters) {
    return gettingEntryService().then((service) => service.getById(...parameters));
  },

  variantGroupsByModel(modelId, depth = 0) {
    return getSpace().then((space) => {
      return space.getEntries({
        'content_type': 'variantGroup', // eslint-disable-line
        'fields.model.sys.id': modelId,
        'order': 'fields.name'
      }).catch(
        processError
      ).then((entries) => {
        return linkResolve(space, entries, depth).then((entries) => {
          return entries.items.map(transformer.contentfulToInternal);
        });
      });
    });
  },

  variantGroupByVariantId(variantId, depth = 0) {
    return getSpace().then((space) => {
      return space.getEntries({
        'content_type': 'variantGroup', // eslint-disable-line
        'fields.variants.sys.id[in]': variantId,
        'order': 'fields.name'
      }).catch(
        processError
      ).then((entries) => {
        return linkResolve(space, entries, depth).then((entries) => {
          return entries.items.map(transformer.contentfulToInternal);
        });
      });
    });
  },

  save(...parameters) {
    return gettingEntryService().then((service) => service.save(...parameters));
  },

  searchByModelId({modelId, query = '', limit = 10, offset = 0, depth = 0}) {
    return getSpace().then((space) => {
      return space.getEntries({
        'query': query,
        'content_type': 'variantGroup', // eslint-disable-line
        'fields.model.sys.id': modelId,
        'skip': offset,
        'limit': limit,
        'order': '-sys.updatedAt'
      }).catch(
        processError
      ).then((entries) => {
        return linkResolve(space, entries, depth).then((entries) => {
          return {
            items: entries.items.map(transformer.contentfulToInternal),
            limit: entries.limit,
            offset: entries.skip,
            total: entries.total
          };
        });
      });
    });
  },

  initializeCustom(...parameters) {
    return gettingEntryService().then((service) => service.initializeCustom('variantGroup', ...parameters));
  },

  create(...parameters) {
    return gettingEntryService().then((service) => service.create('variantGroup', ...parameters));
  },

  archive(...parameters) {
    return gettingEntryService().then((service) => service.archive(...parameters));
  },

  unarchive(...parameters) {
    return gettingEntryService().then((service) => service.unarchive(...parameters));
  },

  publish(...parameters) {
    return gettingEntryService().then((service) => service.publish(...parameters));
  },

  unpublish(...parameters) {
    return gettingEntryService().then((service) => service.unpublish(...parameters));
  }
};
